import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ms-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CFooter = _resolveComponent("CFooter")!

  return (_openBlock(), _createBlock(_component_CFooter, null, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("span", _hoisted_1, "© " + _toDisplayString(new Date().getFullYear()) + " " + _toDisplayString($setup.appName), 1)
      ])
    ]),
    _: 1
  }))
}